import React, { useEffect, useState, useRef } from 'react';
import { Modal, Button, Form, Row, Col, ProgressBar } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { HOPDONGCHITIET_API, HOPDONGNGUYENTAC_API, FILE_MANAGER_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import axios from 'axios';
import { getToken } from '../../../../utils/helper';

const getFileName = (url) => {
    if (!url) return '';
    const parts = url.split('/');
    const lastPart = parts[parts.length - 1];
    const subParts = lastPart.split('\\');
    return subParts[subParts.length - 1];
};

const KhoaDaoTaoModal = ({ isOpen, handleClose, data, refetch }) => {
    const isEdit = !!data;
    const [uploadingField, setUploadingField] = useState(''); // Stores the name of the field currently uploading
    const [uploadProgress, setUploadProgress] = useState(0);

    const fileRefs = {
        congVanDeNghiLink: useRef(null),
        fileHopDongChiTietLink: useRef(null),
        keHoachThucHanhLink: useRef(null),
        fileNghiemThuLink: useRef(null),
        fileThanhLyLink: useRef(null)
    };

    const addMutation = useMutation((payload) => Post(HOPDONGCHITIET_API.CREATE_ITEM, null, payload));
    const updateMutation = useMutation((payload) => Put(HOPDONGCHITIET_API.UPDATE_ITEM, data?.id || data?.Id, payload));

    // Fetch HopDongNguyenTac for dropdown selection (to link with School and Major)
    const { data: contractsData } = useQuery(
        ['contractsDropdown', isOpen],
        () => Get(HOPDONGNGUYENTAC_API.GET_PAGING + '?PageSize=1000'),
        { enabled: isOpen }
    );

    // Fetch Trang thai options from Backend Enum API
    const { data: trangThaiOptionsData } = useQuery(
        ['trangThaiOptions', isOpen],
        () => Get(HOPDONGCHITIET_API.GET_TRANG_THAI_OPTIONS),
        { enabled: isOpen }
    );

    const contracts = contractsData?.data?.$values || contractsData?.data || contractsData?.items?.$values || contractsData?.items || contractsData?.$values || [];
    const statusOptions = trangThaiOptionsData?.$values || trangThaiOptionsData || [];

    const initialValues = {
        hopDongNguyenTacId: data?.hopDongNguyenTacId || data?.HopDongNguyenTacId || '',
        soHopDong: data?.soHopDong || data?.SoHopDong || '',
        tenHopDong: data?.tenHopDong || data?.TenHopDong || '',
        tenKhoaDaoTao: data?.tenKhoaDaoTao || data?.TenKhoaDaoTao || '',
        namHoc: data?.namHoc || data?.NamHoc || '',
        doiTuong: data?.doiTuong || data?.DoiTuong || '',
        ngayKy: data?.ngayKy || data?.NgayKy ? moment(data?.ngayKy || data?.NgayKy).format('YYYY-MM-DD') : '',
        thoiHanHopDong: data?.thoiHanHopDong || data?.ThoiHanHopDong || '',
        ngayKetThuc: data?.ngayKetThuc || data?.NgayKetThuc ? moment(data?.ngayKetThuc || data?.NgayKetThuc).format('YYYY-MM-DD') : '',
        congVanDeNghiLink: data?.congVanDeNghiLink || data?.CongVanDeNghiLink || '',
        fileHopDongChiTietLink: data?.fileHopDongChiTietLink || data?.FileHopDongChiTietLink || '',
        keHoachThucHanhLink: data?.keHoachThucHanhLink || data?.KeHoachThucHanhLink || '',
        fileNghiemThuLink: data?.fileNghiemThuLink || data?.FileNghiemThuLink || '',
        fileThanhLyLink: data?.fileThanhLyLink || data?.FileThanhLyLink || '',
        ghiChu: data?.ghiChu || data?.GhiChu || '',
        trangThai: data?.trangThai || data?.TrangThai || 1
    };

    const validationSchema = Yup.object().shape({
        hopDongNguyenTacId: Yup.string().required('Hợp đồng nguyên tắc liên kết là bắt buộc'),
        namHoc: Yup.string().required('Năm học là bắt buộc'),
        thoiHanHopDong: Yup.number().typeError('Phải là số').nullable()
    });

    const handleFileUpload = async (event, fieldName, setFieldValue) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const fileSizeMB = file.size / 1024 / 1024;
        if (fileSizeMB > 20) {
            toast.error('Kích thước file quá lớn (tối đa 20MB)');
            return;
        }

        try {
            setUploadingField(fieldName);
            setUploadProgress(0);
            const token = await getToken();
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(FILE_MANAGER_API.UPLOAD, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percent);
                }
            });

            const uploadedFile = response?.data?.[0];
            if (uploadedFile && uploadedFile.filePath) {
                setFieldValue(fieldName, uploadedFile.filePath);
                toast.success('Tải lên tệp thành công!');
            } else {
                toast.error('Tải file thất bại');
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Có lỗi xảy ra khi upload file.');
        } finally {
            setUploadingField('');
            setUploadProgress(0);
            if (fileRefs[fieldName]?.current) fileRefs[fieldName].current.value = '';
        }
    };

    const handleSubmit = (values) => {
        const payload = {
            ...values,
            thoiHanHopDong: values.thoiHanHopDong ? parseInt(values.thoiHanHopDong, 10) : null,
            ngayKy: values.ngayKy ? moment(values.ngayKy).toISOString() : null,
            ngayKetThuc: values.ngayKetThuc ? moment(values.ngayKetThuc).toISOString() : null,
            trangThai: parseInt(values.trangThai, 10)
        };

        const mutation = isEdit ? updateMutation : addMutation;
        mutation.mutate(payload, {
            onSuccess: (res) => {
                if (res.id || res.Id || res.status === 200 || res === true) {
                    toast.success(isEdit ? "Cập nhật khóa đào tạo thành công!" : "Thêm mới khóa đào tạo thành công!");
                    refetch();
                    handleClose();
                } else {
                    toast.error("Có lỗi xảy ra khi lưu khóa đào tạo.");
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra.");
            }
        });
    };

    const renderFileSection = (fieldName, label, values, setFieldValue) => {
        const link = values[fieldName];
        return (
            <div className="mb-3 p-3 border rounded bg-light shadow-sm" style={{ borderLeft: '4px solid #007bff', borderRadius: '8px' }}>
                <Row className="align-items-center">
                    <Col md={4}>
                        <div className="font-weight-bold text-dark mb-2 mb-md-0" style={{ fontSize: '0.9rem' }}>{label}</div>
                    </Col>
                    <Col md={8} className="d-flex align-items-center flex-wrap">
                        <Form.Control
                            type="file"
                            ref={fileRefs[fieldName]}
                            onChange={(e) => handleFileUpload(e, fieldName, setFieldValue)}
                            disabled={!!uploadingField}
                            style={{ display: 'none' }}
                            id={`file-upload-${fieldName}`}
                        />
                        <label htmlFor={`file-upload-${fieldName}`} className="btn btn-outline-primary btn-sm mb-0 mr-3" style={{ cursor: 'pointer', borderRadius: '6px' }}>
                            <i className="fas fa-upload mr-1"></i>Chọn tệp
                        </label>
                        {link ? (
                            <div className="d-flex align-items-center flex-grow-1 min-width-0">
                                <a
                                    href={link.startsWith('http') ? link : `${BaseGatewayImage}${link.startsWith('/') ? '' : '/'}${link}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-success text-truncate font-weight-bold mr-2"
                                    style={{ maxWidth: '280px', fontSize: '0.85rem' }}
                                    title={getFileName(link)}
                                >
                                    <i className="fas fa-file-alt mr-1"></i>{getFileName(link)}
                                </a>
                                <Button
                                    variant="link"
                                    className="text-danger p-0"
                                    onClick={() => setFieldValue(fieldName, '')}
                                    style={{ fontSize: '1rem' }}
                                    title="Xóa tệp"
                                >
                                    <i className="fas fa-trash-alt"></i>
                                </Button>
                            </div>
                        ) : null}
                    </Col>
                </Row>
                {uploadingField === fieldName && (
                    <div className="w-100 mt-2">
                        <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} size="sm" animated />
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isEdit ? 'Chỉnh sửa khóa đào tạo' : 'Thêm mới khóa đào tạo'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Hợp đồng nguyên tắc (Liên kết cơ sở & ngành) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="hopDongNguyenTacId"
                                            value={values.hopDongNguyenTacId}
                                            onChange={handleChange}
                                            isInvalid={touched.hopDongNguyenTacId && !!errors.hopDongNguyenTacId}
                                        >
                                            <option value="">-- Chọn hợp đồng nguyên tắc --</option>
                                            {contracts.map((c) => {
                                                const schoolName = c.truongThucTapTen || c.TruongThucTapTen || c.truongThucTap?.tenTruong || c.truongThucTap?.TenTruong || '';
                                                const programName = c.chuongTrinhDaoTaoTen || c.ChuongTrinhDaoTaoTen || c.chuongTrinhDaoTao?.tenChuongTrinh || c.chuongTrinhDaoTao?.TenChuongTrinh || '';
                                                const contractName = c.tenHopDong || c.TenHopDong || '';
                                                return (
                                                    <option key={c.id || c.Id} value={c.id || c.Id}>
                                                        {c.soHopDong} - {contractName} - {schoolName} ({programName})
                                                    </option>
                                                );
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{errors.hopDongNguyenTacId}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Số HĐ chi tiết</Form.Label>
                                        <Form.Control
                                            name="soHopDong"
                                            value={values.soHopDong}
                                            onChange={handleChange}
                                            isInvalid={touched.soHopDong && !!errors.soHopDong}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.soHopDong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên hợp đồng chi tiết</Form.Label>
                                        <Form.Control
                                            name="tenHopDong"
                                            value={values.tenHopDong}
                                            onChange={handleChange}
                                            isInvalid={touched.tenHopDong && !!errors.tenHopDong}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenHopDong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên khóa đào tạo hiển thị</Form.Label>
                                        <Form.Control
                                            name="tenKhoaDaoTao"
                                            placeholder="VD: Lớp thực hành lâm sàng Nội khoa K27"
                                            value={values.tenKhoaDaoTao}
                                            onChange={handleChange}
                                            isInvalid={touched.tenKhoaDaoTao && !!errors.tenKhoaDaoTao}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenKhoaDaoTao}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Năm học <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="namHoc"
                                            placeholder="VD: 2025-2026"
                                            value={values.namHoc}
                                            onChange={handleChange}
                                            isInvalid={touched.namHoc && !!errors.namHoc}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.namHoc}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Đối tượng học viên</Form.Label>
                                        <Form.Control
                                            name="doiTuong"
                                            placeholder="VD: Bác sĩ, Điều dưỡng..."
                                            value={values.doiTuong}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ngày ký</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayKy"
                                            value={values.ngayKy}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Thời hạn HĐ (tháng)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="thoiHanHopDong"
                                            value={values.thoiHanHopDong}
                                            onChange={handleChange}
                                            isInvalid={touched.thoiHanHopDong && !!errors.thoiHanHopDong}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.thoiHanHopDong}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ngày kết thúc</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayKetThuc"
                                            value={values.ngayKetThuc}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <h6 className="border-bottom pb-2 mt-3 font-weight-bold text-secondary">
                                        <i className="fas fa-file-upload mr-2"></i>Hồ sơ đính kèm (Tối đa 20MB/file)
                                    </h6>
                                </Col>
                                <Col md={12}>
                                    {renderFileSection('congVanDeNghiLink', '1. Đề nghị thực hành', values, setFieldValue)}
                                </Col>
                                <Col md={12}>
                                    {renderFileSection('fileHopDongChiTietLink', '2. Hợp đồng chi tiết', values, setFieldValue)}
                                </Col>
                                <Col md={12}>
                                    {renderFileSection('keHoachThucHanhLink', '3. Kế hoạch thực hành', values, setFieldValue)}
                                </Col>
                                <Col md={12}>
                                    {renderFileSection('fileNghiemThuLink', '4. Biên bản nghiệm thu', values, setFieldValue)}
                                </Col>
                                <Col md={12}>
                                    {renderFileSection('fileThanhLyLink', '5. Biên bản thanh lý', values, setFieldValue)}
                                </Col>
                                <Col md={6}>
                                     <Form.Group className="mb-3">
                                         <Form.Label className="font-weight-bold" style={{ fontSize: '0.85rem' }}>Trạng thái</Form.Label>
                                         <Form.Control
                                             as="select"
                                             name="trangThai"
                                             value={values.trangThai}
                                             onChange={handleChange}
                                         >
                                             {statusOptions.length > 0 ? (
                                                 statusOptions.map((opt) => (
                                                     <option key={opt.value || opt.Value} value={opt.value || opt.Value}>
                                                         {opt.name || opt.Name}
                                                     </option>
                                                 ))
                                             ) : (
                                                 <>
                                                     <option value={1}>Mới tạo / Chờ xử lý</option>
                                                     <option value={2}>Đang thực hiện</option>
                                                     <option value={3}>Đã hoàn thành</option>
                                                     <option value={4}>Tạm dừng</option>
                                                     <option value={5}>Đã hủy</option>
                                                 </>
                                             )}
                                         </Form.Control>
                                     </Form.Group>
                                 </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ghi chú</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="ghiChu"
                                            value={values.ghiChu}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer className="bg-light">
                            <Button variant="secondary" onClick={handleClose}>
                                Đóng
                            </Button>
                            <Button variant="primary" type="submit" disabled={addMutation.isLoading || updateMutation.isLoading || !!uploadingField}>
                                <i className="fas fa-save mr-1"></i>Lưu lại
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default KhoaDaoTaoModal;
